import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PackIllustration } from './PackIllustration';
import { images } from '../data/images';
const chips = ['6 Volumes', '54 Sessions', '5 Bonuses', '300 Pages', 'Seated Swap in every move'];
const builtFor = ['Dance/movement therapists', 'DMT trainees', 'Creative arts therapists', 'Recreation therapists', 'Activity professionals'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it, read it once, lead it'];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-light" data-id="element-115" data-mp="sb1bbp9ejz61">
      {/* Flowing curves from the pack cover: teal spine wave, sand sweep, sage corner */}
      <svg viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice" className="pointer-events-none absolute inset-0 h-full w-full" aria-hidden="true" data-id="element-116" data-mp="nbygexn4z9bs">
        <path d="M0 0 H150 C 110 160, 210 260, 140 420 C 80 560, 170 700, 90 900 H0 Z" className="fill-court" fillOpacity="0.9" data-id="element-117" data-mp="380w020y5mzeq" />
        <path d="M620 0 H1440 V150 C 1260 230, 1040 210, 900 160 C 780 120, 690 80, 620 0 Z" className="fill-shuttle" fillOpacity="0.55" data-id="element-118" data-mp="3j6odtpknkwsq" />
        <path d="M1440 900 H1120 C 1180 820, 1300 780, 1440 760 Z" className="fill-green" fillOpacity="0.55" data-id="element-119" data-mp="39b4gqzucrs2e" />
      </svg>

      <div className="relative max-w-6xl mx-auto pl-12 pr-5 pt-7 pb-14 sm:pl-20 sm:pt-12 sm:pb-20 xl:pl-5" data-id="element-120" data-mp="3e7uwfm28wlna">
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-121" data-mp="30gq4l654cxni">
          <div data-id="element-122" data-mp="35aatm8oqihak">
            <p className="inline-flex items-center gap-2 rounded-full bg-court-soft px-3 py-1.5 text-[11px] font-bold uppercase tracking-[1.4px] text-court-deep" data-id="element-123" data-mp="35a2jupnwrs3l">
              <span className="h-1.5 w-1.5 rounded-full bg-court" data-id="element-124" data-mp="2vjzoiitbe223" />
              For therapists who lead movement groups
            </p>
            <h1 className="mt-4 font-display font-bold text-ink text-[34px] leading-[1.08] tracking-tight sm:text-5xl md:text-6xl" data-id="element-125" data-mp="2hl9s75ebk6es">
              You never know who will walk in.{' '}
              <span className="text-court-deep bg-[linear-gradient(transparent_68%,rgba(235,192,106,0.6)_68%)]" data-id="element-126" data-mp="s3mfk97g6b1j">
                Your session is ready anyway.
              </span>
            </h1>
            <p className="mt-5 max-w-xl text-base sm:text-lg text-ink-soft" data-id="element-127" data-mp="icrngo7ish86">
              Movement Group Ready is a six-volume pack of 54 complete movement
              group sessions: warm-up, theme, develop and close, timed for 30, 45
              or 60 minutes. Every session comes in a low, steady and high-energy
              version, with a seated and wheelchair option for every move. Walk
              in with a plan and still follow your group&apos;s lead.
            </p>
            <ul className="mt-5 flex flex-wrap gap-2" data-id="element-128" data-mp="x0cq6h0hgefk">
              {chips.map(chip => <li key={chip} className="rounded-full border border-line bg-white px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-ink-soft" data-id="element-129" data-mp="3lu07neppzt62">
                  {chip}
                </li>)}
            </ul>
          </div>

          {images.hero ? <img src={images.hero} alt="Movement Group Ready: six volumes of ready-to-adapt movement group sessions" width={1024} height={1024} className="w-full h-auto rounded-3xl shadow-card ring-1 ring-ink/5" data-id="element-130" data-mp="218tols8th4da" /> : <PackIllustration data-id="element-131" data-mp="2g256ks1cguyb" />}
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-132" data-mp="2kxkivfjpeism">
          <div className="w-full max-w-md" data-id="element-133" data-mp="2p0qp4n6tg9z3">
            <CtaButton data-id="element-134" data-mp="2p10f4arv2h4s">Get Movement Group Ready</CtaButton>
          </div>

          <div className="mt-5 text-center" data-id="element-135" data-mp="2tztuy9umek84">
            <p className="text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-136" data-mp="2txhdrywosdw4">
              Built for
            </p>
            <ul className="mt-2 flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-137" data-mp="zlaq40mlw4mx">
              {builtFor.map(who => <li key={who} className="flex items-center gap-1.5 text-[13px] font-semibold text-ink" data-id="element-138" data-mp="4akwoxpqsifg">
                  <span className="flex h-4 w-4 items-center justify-center rounded-full bg-green" data-id="element-139" data-mp="3vgni4u78vzrw">
                    <CheckIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-140" data-mp="e8innsyzktbr" />
                  </span>
                  {who}
                </li>)}
            </ul>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-ink-soft" data-id="element-141" data-mp="3hr25s2nyaisu">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-142" data-mp="3cp34cybrtvyj">
                <span className="h-1.5 w-1.5 rounded-full bg-shuttle" data-id="element-143" data-mp="3rgvgl1g9qtw1" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}